import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IApiResponse } from '@web/shared-types';
import { IRelationProductGroupQuery, TariffProductGroup } from '@web/dtos';
import { AppConfigService } from '../../app-config.service';

@Injectable({ providedIn: 'root' })
export class OnDemandRelationProductGroupGateway {
  private readonly configService = inject(AppConfigService);
  private readonly builder = new RestCallBuilder<void, TariffProductGroup[]>(
    []
  );

  getRelationProductGroups(
    query: IRelationProductGroupQuery
  ): Observable<IApiResponse<TariffProductGroup[]>> {
    const params: Record<string, any> = {
      serviceAreaId: query.serviceAreaId,
      origin: query.origin,
      destination: query.destination,
      dateTime: query.dateTime,
    };
    if (query.via) params['via'] = query.via;

    return this.builder
      .getExternal(
        `${this.configService.get().general.tariffUrl}/tariff/relation-product-groups`,
        params
      )
      .handleMessages()
      .build();
  }
}
